<template>
  <div>
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="教室名称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.placeName"
          ></a-input>
        </a-form-item>
        <a-form-item label="容纳人数范围">
          <a-input-group compact>
            <a-input-number
              :min="1"
              v-model="queryParam.minCapacity"
              class="person-scope"
              placeholder="请输入"
            />
            <a-input class="person-gap" placeholder="~" disabled />
            <a-input-number
              :min="1"
              v-model="queryParam.maxCapacity"
              class="person-scope max-person"
              placeholder="请输入"
            />
          </a-input-group>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchClassroom()">查询</a-button>
          <a-button @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="list-oper">
      <a-button
        type="primary"
        icon="plus"
        @click="$refs.classroomForm.init('add')"
        >新建</a-button
      >
      <div class="import-excel">
        <a-button type="primary" icon="plus" @click="$refs.classroomFile.init()"
          >导入教室</a-button
        >
      </div>
      <a-button
        type="primary"
        class="select-row"
        v-if="openAllIndex == '0'"
        @click="openAllIndex = '1'"
        >批量删除</a-button
      >
      <template v-if="openAllIndex == '1'">
        <a-button type="primary" class="select-row" @click="deleteSelectRow()"
          >删除</a-button
        >
        <a-button type="primary" class="select-row" @click="openAllIndex = '0'"
          >取消</a-button
        >
      </template>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="classroomList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
      rowKey="id"
      :rowSelection="openAllIndex != '0' ? rowSelection : null"
    >
      <span slot="capacity" slot-scope="text, record">
        <template>
          <span>{{ record.capacity }}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.classroomForm.init('update', record)">修改</a>
        </template>
      </span>
    </a-table>
    <classroom-form-modal
      ref="classroomForm"
      @addClassroom="addClassroom"
    ></classroom-form-modal>

    <classroom-file-modal
      ref="classroomFile"
      @refreshList="getClassroomList()"
    ></classroom-file-modal>
  </div>
</template>
<script>
import classroom from '../../api/classroom'

import ClassroomFormModal from './ClassroomFormModal'

import ClassroomFileModal from './components/ClassroomFileModal'

const columns = [
  {
    title: '教室名称',
    dataIndex: 'placeName',
  },
  {
    title: '最大容纳人数',
    dataIndex: 'capacity',
    scopedSlots: { customRender: 'capacity' },
    sorter: true,
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'classroom',
  data() {
    return {
      classroomList: [], //教室数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      loading: true,
      openAllIndex: '0', //是否开启全部选择
      selectedRowKeys: [], //table选中的项目list
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  components: {
    ClassroomFileModal,
    ClassroomFormModal,
  },
  methods: {
    //表格删除选中的学生
    deleteSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选删除项')
        return
      }
      classroom
        .batchDelete({ ids: this.selectedRowKeys.join() })
        .then((res) => {
          this.$message.success('删除成功')
          this.getClassroomList()
          this.selectedRowKeys = []
        })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getClassroomList(obj)
    },

    //新增一个教室
    addClassroom(classroom) {
      this.classroomList.unshift(classroom)
    },

    //查询教室
    searchClassroom() {
      this.queryParam.currentPage = 1
      this.queryParam.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      this.getClassroomList(this.queryParam)
    },

    //教室列表
    getClassroomList(params) {
      this.loading = true
      classroom.getClassroomList(params).then((res) => {
        console.log('当前的教室列表是', res.data.list)
        this.classroomList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //刷新学校
    refreshSchool() {
      this.getClassroomList(this.queryParam)
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    if (this.$store.getters.schoolId) {
      this.getClassroomList(this.queryParam)
    }
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
.person-scope {
  width: 100px;
  text-align: center;
}
.max-person {
  border-left: none;
}
.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;
}
</style>
